import React from 'react'
export const TelegramIcon = ({
  width = '25',
  height = '24',
  className = 'fill-white'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.2949 22.5C18.0939 22.5 22.7949 17.799 22.7949 12C22.7949 6.20101 18.0939 1.5 12.2949 1.5C6.49593 1.5 1.79492 6.20101 1.79492 12C1.79492 17.799 6.49593 22.5 12.2949 22.5Z"
        fill="url(#paint0_linear_6899_33983)"
      />
      <path d="M17.5349 7.6566C17.6283 7.05249 17.054 6.57566 16.5168 6.8115L5.81853 11.5086C5.43334 11.6777 5.46152 12.2612 5.86102 12.3884L8.06724 13.091C8.48837 13.2251 8.9443 13.1557 9.31202 12.9017L14.2862 9.46522C14.4362 9.36157 14.5997 9.57487 14.4715 9.70695L10.891 13.3984C10.5437 13.7566 10.6126 14.3634 11.0304 14.6254L15.0392 17.1392C15.4888 17.4212 16.0672 17.1379 16.1513 16.5946L17.5349 7.6566Z" />
      <defs>
        <linearGradient
          id="paint0_linear_6899_33983"
          x1="12.2949"
          y1="1.5"
          x2="12.2949"
          y2="22.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37BBFE" />
          <stop offset="1" stopColor="#007DBB" />
        </linearGradient>
      </defs>
    </svg>
  )
}
